import React, { FunctionComponent, useEffect } from "react";
import { Hub } from "aws-amplify";
import RedirectToReferrer from "../redirect/RedirectToReferrer";
import Intermission from "../components/Intermission";

export const PostLogin: FunctionComponent = () => {

  useEffect(() => {
    let didRedirect = false;

    // Listen for successful authentication via Hub events
    const hubListener = Hub.listen('auth', ({ payload: { event } }) => {
      if (event === 'signIn' && !didRedirect) {
        console.log("successfully received token, redirecting...")
        didRedirect = true;
        RedirectToReferrer();
      }
    });

    // Fallback timeout: redirect after 30 seconds if auth event doesn't fire
    const timeoutId = setTimeout(() => {
      if (!didRedirect) {
        didRedirect = true;
        RedirectToReferrer();
      }
    }, 30000);

    // Cleanup listeners on unmount
    return () => {
      hubListener();
      clearTimeout(timeoutId);
    };
  }, []);

  return (<Intermission />)
}
